define(function (require) {
    var $ = require("jquery");
    var $form = $(".news-taxonomy-filter-form");
    var $page = $form.find("input[name=page]");
    var $sel = $("select.taxonomy-filter-secondary");
    var $audienceButtons = $("button.filter-button.for-audience");
    var $audienceExclusions = $("span[name=audienceExclusions]");

    var _select_change = function (e) {
        $page.val("1");
        $form.submit();
    };
    var _audienceButton_click = function (e) {
        e.preventDefault();
        $audienceExclusions.empty();

        var isSelected = $(e.target).attr("aria-selected") === "true";
        var appendAudienceExclusion = function (index, item) {
            $audienceExclusions.append('<input type="hidden" name="excludedAudience" value="' + $(item).text() + '"/>');
        };

        $(e.target).attr("aria-selected", (!isSelected).toString());
        $audienceExclusions.empty();
        $audienceButtons.filter("[aria-selected!=true]").each(appendAudienceExclusion);
        $page.val(1);
        $form.submit();

        return false;
    };

    var init = function () {
        $("nav.pagination-container li.active a").click(function (e) {
            e.preventDefault();
            return false;
        });
        $sel.change(_select_change);
        $audienceButtons.on("click", _audienceButton_click);
    };

    init();
});
